import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Link,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import Moment from "react-moment";
import swal from "sweetalert";
import "./Course.css";
import { Modal, Button } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert"; // Import

export default function CourseDetails(props) {
  const baseurlapi = props.baseurlapi;
  const [Coursearr, setCoursearr] = useState([]);
  const [Comments, setComments] = useState([]);
  const [openCommentmodel, setCommentmodel] = useState(false);
  const [openInfomodel, setInfomodel] = useState(false);


  const [rating, setRating] = useState(0);
  const stars = [1, 2, 3, 4, 5];
  let limit = props.limit || 5;
  const [initialValue, setInitialValue] = useState();
  const [ratingstatus, setratingstatus] = useState("");
  const [likestatus, setlikestatus] = useState("");
  const [openLoginmodel, setLogin] = useState(false);
  const [opensignupmodel, setSignup] = useState(false);

  const { pathname } = useLocation();
  const [ads, setads] = useState([]);
  const params = useParams();
  const id = params.id;


  //  for the form data

  const [name, setName] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [className, setClassName] = useState("");
  const [school, setSchool] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [nameofp, setNameOfP] = useState("");
  const [amount, setAmount] = useState('');
  const [infodata, setInfordata] = useState('');


  const [courseid, setCourseid] = useState(params.id);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // session check
  var LoginData = sessionStorage.getItem("LoginData");
  if (LoginData == null || LoginData == "") {
    var userid = "";
    var roleid = "";
  } else {
    //  var  obj ={ userid: '', Name: '', Role: ''}
    //  sessionStorage.setItem('LoginData', JSON.stringify(obj));
    var data = JSON.parse(LoginData);
    var userid = data.userid;
    var roleid = data.Role;
  }

  useEffect(() => {
    axios.get(baseurlapi + "/Coursebyid.php?id=" + id).then((response2) => {
      setCoursearr(response2.data.Coursearr);

      console.log('response2.data.Coursearr', response2.data.Coursearr);
    });
    window.scrollTo(0, 0);
  }, [pathname]);

  // payment function

  // Function to create and submit hidden form to PayU
  const submitPayUForm = (paymentUrl, payuParams) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = paymentUrl;

    Object.keys(payuParams).forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = payuParams[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) {
      alert('Please wait for the current payment to finish.');
      return;
    }

    setIsSubmitting(true);

    const payload = {
      name,
      mobileno,
      email,
      dob,
      className,
      school,
      city,
      country,
      nameofp,
      amount,
      courseid,
    };

    console.log('Payload:', payload);

    try {
      const response = await fetch(baseurlapi + '/PayUPayment.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.paymentUrl && data.payuParams) {
        // Submit to PayU
        submitPayUForm(data.paymentUrl, data.payuParams);
      } else if (data.error) {
        alert('Error: ' + data.error);
        console.error(data.error);
      } else {
        alert('Failed to initiate payment.');
      }
    } catch (error) {
      console.error('Payment initiation error:', error);
      alert('Payment initiation failed. Please try again.');
    } finally {
      setTimeout(() => {
        window.isPayUProcessing = false;
      }, 3000); // Prevent multiple requests within 3 seconds
    }
  };

  const OpenCommentmodel = (amt) => {
    setAmount(amt);
    setCommentmodel(true);
  };

  const CommentClose = () => setCommentmodel(false);


  const OpenInfomodel = (val) => {
    setInfordata(val);
    setInfomodel(true);
  };

  const InfoClose = () => setInfomodel(false);


  // lavel array
  const levels = [
    "Level 1 , White Scroll ( Beginner )",
    "Level 2 , Ink Belt ( Early Learner )",
    "Level 3 , Quill Warrior ( Intermediate )",
    "Level 4 , Master of Ink (Advanced )"
  ];


  return (
    <>
      <div className="container-fluid p-t-20 p-b-10 bgcolorFFFFFF border-1px">
        {Coursearr.map((course, index) => (
          <div className="container2 mt-0" key={index}>
            <div className="row">
              <div className="col-md-12">
                <h2 style={{ marginTop: "0px",marginBottom:"20px" }} className="PoppinsLight text-center">{course.coursename}</h2>
                <div>
                  <img src={course.image} className="courseimg" />
                </div>
                <br />
                <p className="PoppinsLight">{course.description}</p>

              </div>

            </div>

            <hr />
            {/* <div className="row">
             
              <div className="col-md-3">
                <div className="card subscription-card text-white text-center py-4 px-3">
                  <h5 className="mb-3"> Level 1 </h5>
                  <h2 className="mb-2">
                    ₹{course.l1PriceOrFee}
                  </h2>
                  <button className="btn btn-light mt-3 mb-4 fw-semibold" onClick={() => OpenCommentmodel(course.l1PriceOrFee)}>
                    Buy Now
                  </button>

                  <ul className="mt-0 text-left">
                    <li> <span className=""> <b>For Whom : </b></span> {course.l1ForWhom}</li>
                    <li><span className=""> <b>No of Classes: </b></span> {course.l1NoOfClasses}</li>
                    <li><span className=""> <b>Day on which course is conducted : </b></span> {course.l1DayOnWhichCourseIsConducted}</li>
                    <li><span className=""> <b>Timings : </b></span> {course.l1Timings}</li>
                    <li><span className=""> <b>Starts when : </b></span> {course.l1StartsWhen}</li>
                    <li><span className=""> <b>Ends when : </b></span> {course.l1EndsWhen}</li>
                    <li>
                      {course.l1WhatWillTheyLearn != '' ? (<>What will they learn? <button className="btn   fw-semibold flr" onClick={() => OpenInfomodel(course.l1WhatWillTheyLearn)}>
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </button></>) : null}
                    </li>
                    <li>
                      {course.l1HowWillTheyLearn != '' ? (<>How will they learn <button className="btn   fw-semibold flr" onClick={() => OpenInfomodel(course.l1HowWillTheyLearn)}>
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </button></>) : null}
                    </li>
                    <li>
                      {course.l1CourseCurriculum != '' ? (<>Course Curriculum <button className="btn  fw-semibold flr" onClick={() => OpenInfomodel(course.l1CourseCurriculum)}>
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </button></>) : null}
                    </li>

                  </ul>


                </div>
              </div>

            </div> */}
            <div className="row">
              {Array.from({ length: 5 }).map((_, index) => {
                const price = course[`l${index + 1}PriceOrFee`];

                // Skip rendering the card if price is not greater than zero
                if (!(price > 0)) return null;

                return (
                  <div className="col-md-3 mb-2" key={index}>
                    <div className="card subscription-card text-white text-center py-4 px-3">
                      <h6 className="mb-3 priceheadingtext">
                       
                        {index + 1 === 1
                          ? ' White Scroll ( Beginner )'
                          : index + 1 === 2
                            ? '  Ink Belt ( Early Learner )'
                            : index + 1 === 3
                              ? '  Quill Warrior ( Intermediate )'
                              : index + 1 === 4
                                ? '  Master of Ink (Advanced )'
                                : ''}
                      </h6>

                      <h3 className="mb-2">₹{price}</h3>

                      <button className="btn btn-light mt-3 mb-4 fw-semibold PoppinsLight" onClick={() => OpenCommentmodel(price)}>
                        Enroll Now
                      </button>

                      <ul className="mt-0 text-left">
                        {course[`l${index + 1}ForWhom`] && (
                          <li><span className="maintext"><b>For Whom : </b></span>  <span className="subtext">{course[`l${index + 1}ForWhom`]}</span> </li>
                        )}
                        {course[`l${index + 1}NoOfClasses`] && (
                          <li><span className="maintext"><b>No of Classes : </b></span> <span className="subtext">{course[`l${index + 1}NoOfClasses`]}</span></li>
                        )}
                        {course[`l${index + 1}DayOnWhichCourseIsConducted`] && (
                          <li><span className="maintext"><b>Day on which course is conducted : </b></span> <span className="subtext">{course[`l${index + 1}DayOnWhichCourseIsConducted`]}</span></li>
                        )}
                        {course[`l${index + 1}Timings`] && (
                          <li><span className="maintext"><b>Timings : </b></span> <span className="subtext">{course[`l${index + 1}Timings`]}</span></li>
                        )}
                        {course[`l${index + 1}StartsWhen`] && (
                          <li><span className="maintext"><b>Starts when : </b></span> <span className="subtext">{course[`l${index + 1}StartsWhen`]}</span></li>
                        )}
                        {course[`l${index + 1}EndsWhen`] && (
                          <li><span className="maintext"><b>Ends when : </b></span> <span className="subtext">{course[`l${index + 1}EndsWhen`]}</span></li>
                        )}
                        {course[`l${index + 1}AnyCertificationsAndPrizes`] && (
                          <li><span className="maintext"><b>Any certifications and prizes : </b></span> <span className="subtext">{course[`l${index + 1}AnyCertificationsAndPrizes`]}</span></li>
                        )}
                        {course[`l${index + 1}WhatWillTheyLearn`] && (
                          <li className="stktext">
                            What will they learn? <span className="text-black fw-semibold flr cp" onClick={() => OpenInfomodel(course[`l${index + 1}WhatWillTheyLearn`])}>
                              <i className="fa fa-eye" aria-hidden="true"></i>
                            </span>
                          </li>
                        )}
                        {course[`l${index + 1}HowWillTheyLearn`] && (
                          <li className="stktext">
                            How will they learn <span className="text-black fw-semibold flr cp" onClick={() => OpenInfomodel(course[`l${index + 1}HowWillTheyLearn`])}>
                              <i className="fa fa-eye" aria-hidden="true"></i>
                            </span>
                          </li>
                        )}
                        {course[`l${index + 1}CourseCurriculum`] && (
                          <li className="stktext">
                            Course Curriculum <span className="text-black fw-semibold flr cp" onClick={() => OpenInfomodel(course[`l${index + 1}CourseCurriculum`])}>
                              <i className="fa fa-eye" aria-hidden="true"></i>
                            </span>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>




          </div>
        ))}
      </div>

      <Modal
        show={openCommentmodel}
        onHide={CommentClose}
        animation={false}
        size="lg" // Large size modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className=" border-0"></Modal.Header>
        <Modal.Body className=" " style={{ borderRadius: "0px 0px 10px 10px" }}>
          <div className="container ">
            <form onSubmit={handleSubmit}>
              <div className="row mt-0">

                <div className="col-md-6">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    placeholder="Enter your name.."
                    className="form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="mobileno" className="form-label">
                    Mobile No.
                  </label>
                  <input
                    type="tel"
                    id="mobileno"
                    value={mobileno}
                    onChange={(e) => setMobileno(e.target.value)}
                    required
                    placeholder="Enter your mobile no.."
                    className="form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="Enter your email.."
                    className="form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="dob" className="form-label">
                    DOB
                  </label>
                  <input
                    type="date"
                    id="dob"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    required
                    className="form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="class" className="form-label">
                    Class
                  </label>
                  <input
                    type="text"
                    id="class"
                    value={className}
                    onChange={(e) => setClassName(e.target.value)}
                    required
                    placeholder="Enter your class.."
                    className="form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="school" className="form-label">
                    School
                  </label>
                  <input
                    type="text"
                    id="school"
                    value={school}
                    onChange={(e) => setSchool(e.target.value)}
                    required
                    placeholder="Enter your school.."
                    className="form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="city" className="form-label">
                    City
                  </label>
                  <input
                    type="text"
                    id="city"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    required
                    placeholder="Enter your city.."
                    className="form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="country" className="form-label">
                    Country
                  </label>
                  <input
                    type="text"
                    id="country"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    required
                    placeholder="Enter your country.."
                    className="form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="nameofp" className="form-label">
                    Name of Parent
                  </label>
                  <input
                    type="text"
                    id="nameofp"
                    value={nameofp}
                    onChange={(e) => setNameOfP(e.target.value)}
                    required
                    placeholder="Enter your parent’s name.."
                    className="form-control"
                  />
                </div>

                <div className="col-12 mt-4">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>


      {/* info model */}

      <Modal
        show={openInfomodel}
        onHide={InfoClose}
        animation={false}
        size="lg" // Large size modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className=" border-0"> Details </Modal.Header>
        <Modal.Body className=" " style={{ borderRadius: "0px 0px 10px 10px" }}>
          <div className="container ">

            <div className="row">
              <div className="col-md-12">

                <div className="PoppinsLight" dangerouslySetInnerHTML={{ __html: infodata }}></div>
              </div>
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
